<!-- begin:: Page -->
<div class="m-grid m-grid--hor m-grid--root m-page">
    <!-- begin::Header -->
   
    <!-- end::Header -->
    <!-- begin::Body -->
    <div class="m-container">
  
      <div class="m-grid__item m-grid__item--fluid m-wrapper marginTop">
        <!-- END: Subheader -->
        <div class="m-content">
  
          <!--begin::Portlet-->
          <div class="m-portlet m-portlet--tab">
            <div class="row">
              <div class="col-md-12">
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="row">
                      <div class="col-md-8 col-lg-8">
                        <div class="m-portlet__head-title">
                          <span class="m-portlet__head-icon m--hide">
                            <i class="la la-gear"></i>
                          </span>
                          <h2 class="m-portlet__head-text">
                            Training Centre CAAF Registration Form
                          </h2>
                        </div>
                      </div>
                      <div class="col-md-4 col-lg-4">
                        <div class="m-portlet__head-title title-right">
                          <span class="m-portlet__head-icon m--hide">
                            <i class="la la-gear"></i>
                          </span>
                          <button class="btn btn-next" *ngIf="showPrevious()" (click)="prev()">Previous</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <!--end: Message container -->
              <!-- <div class="row"> -->
              <div class="col-md-4 left-sidebar m-wizard m-wizard--3 m-wizard--success m-wizard--step-first">
                <button class="m-aside-left-close m-aside-left-close--skin-light" id="m_aside_left_close_btn">
                  <i class="la la-close"></i>
                </button>
  
                <div class="m-wizard__head">
  
              <!--begin: Form Wizard Progress -->
              <div class="m-wizard__progress">
                <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"  
                  [ngStyle]="{'width': currentStep==1 ? 'calc(20% + 28px)' : currentStep==2 ?
                   'calc(40% + 28px)' : currentStep==3 ? 'calc(60% + 28px)' : currentStep==4
                    ? 'calc(80% + 28px)' : currentStep==5 ? 'calc(100% + 28px)' :'calc(100% + 28px)'}"></div>
                </div>
              </div>
                    <!--end: Form Wizard Progress -->
  
                    <!--begin: Form Wizard Nav -->
              <div class="m-wizard__nav">
                <div class="m-wizard__steps">
                  <div class="m-wizard__step m-wizard__step--current" m-wizard-target="m_wizard_form_step_1">
                    <div class="m-wizard__step-info" (click)="navigation('general')">
                      <a href="javascript:void(0);"  [ngClass]="{'m-wizard__step--current': currentStep==1 || currentStep>1}"class="m-wizard__step-number">
                        <span><span>1</span></span>
                      </a>
                      <div class="m-wizard__step-label">
                        General Details
                      </div>
                      <div class="m-wizard__step-sub-label">
                        <span class="sub-label">Training Partner Name</span>
                        <span class="sub-label">Training Centre Name</span>
                        <span class="sub-label">Website Details</span>
                        <span class="sub-label">Centre Address</span>
                      </div>
                    </div>
                  </div>
                  <div class="m-wizard__step" [ngClass]="{'m-wizard__step--current': currentStep==2 || currentStep>2}" m-wizard-target="m_wizard_form_step_2">
                    <div class="m-wizard__step-info"(click)="navigation('facility')">
                      <a href="javascript:void(0);" class="m-wizard__step-number">
                        <span><span>2</span></span>
                      </a>
                      <div class="m-wizard__step-label">
                        Facilities at Centre
                      </div>
                      <div class="m-wizard__step-sub-label">
                        <span class="sub-label">Facilities Available</span>
                        <span class="sub-label">Commendations</span>
                        <span class="sub-label">Residential for Men & Women</span>
                        <span class="sub-label">Differently Abled & Hygiene</span>
                      </div>
                    </div>
                  </div>
                  <div class="m-wizard__step"[ngClass]="{'m-wizard__step--current': currentStep==3 || currentStep>3}" m-wizard-target="m_wizard_form_step_3">
                    <div class="m-wizard__step-info"(click)="navigation('jobRole')">
                      <a href="javascript:void(0);" class="m-wizard__step-number">
                        <span><span>3</span></span>
                      </a>
                      <div class="m-wizard__step-label">
                        Job Role & Infrastructure
                      </div>
                      <div class="m-wizard__step-sub-label">
                        <span class="sub-label">Add Job Roles</span>
                        <span class="sub-label">Proposed Batch Details</span>
                        <span class="sub-label">Classroom Details</span>
                        <span class="sub-label">Laboratory Details</span>
                        <span class="sub-label">Trainer Details</span>
                      </div>
                    </div>
                  </div>
                  <div class="m-wizard__step" [ngClass]="{'m-wizard__step--current': currentStep==4 || currentStep>4}"m-wizard-target="m_wizard_form_step_4">
                    <div class="m-wizard__step-info"(click)="navigation('centreArea')">
                      <a href="javascript:void(0);" class="m-wizard__step-number">
                        <span><span>4</span></span>
                      </a>
                      <div class="m-wizard__step-label">
                        Centre Areas
                      </div>
                      <div class="m-wizard__step-sub-label">
                        <span class="sub-label">Area Type</span>
                        <span class="sub-label">Area Details</span>
                        <span class="sub-label">Facilities Available</span>
                      </div>
                    </div>
                  </div>
                  <div class="m-wizard__step"[ngClass]="{'m-wizard__step--current': currentStep==5 || currentStep>5}" m-wizard-target="m_wizard_form_step_5">
                    <div class="m-wizard__step-info" (click)="navigation('centreStaff')">
                      <a href="javascript:void(0);" class="m-wizard__step-number">
                        <span><span>5</span></span>
                      </a>
                      <div class="m-wizard__step-label">
                        Centre Staff
                      </div>
                      <div class="m-wizard__step-sub-label">
                        <span class="sub-label">Name & Type of Support Staff</span>
                        <span class="sub-label">Highest Qualification</span>
                        <span class="sub-label">Years of Experience</span>
                        <span class="sub-label">Dedicated Resource</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="m-wizard__step"[ngClass]="{'m-wizard__step--current': currentStep==6 || currentStep>6}" m-wizard-target="m_wizard_form_step_6">
                    <div class="m-wizard__step-info" (click)="navigation('uploadPhoto')">
                      <a href="javascript:void(0);" class="m-wizard__step-number">
                        <span><span>6</span></span>
                      </a>
                      <div class="m-wizard__step-label">
                        Upload Photos from Mobile
                      </div>
                      <div class="m-wizard__step-sub-label">
                      </div>
                    </div>
                  </div>  -->
                   <!-- <div class="m-wizard__step"[ngClass]="{'m-wizard__step--current': currentStep==7 || currentStep>7}" m-wizard-target="m_wizard_form_step_6">
                    <div class="m-wizard__step-info" (click)="navigation('declaration')">
                      <a href="javascript:void(0);" class="m-wizard__step-number">
                        <span><span>7</span></span>
                      </a>
                      <div class="m-wizard__step-label">
                        Declaration & Submission
                      </div>
                      <div class="m-wizard__step-sub-label">
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
              <!-- end: Form Wizard Nav --> 
            </div>
  
              </div>
              <div class="col-md-8" style="padding-right: 29px; padding-top: 29px">
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  